import { dual } from '../../Function/dist/effect-Function.esm.js';
import { DifferTypeId, make as make$1, environment as environment$1, chunk as chunk$1, hashMap as hashMap$1, hashSet as hashSet$1, orElseEither as orElseEither$1, transform as transform$1, update as update$1, updateWith as updateWith$1, zip as zip$1 } from '../../internal/Differ.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */
const TypeId = DifferTypeId;

/**
 * @since 2.0.0
 */

/**
 * An empty patch that describes no changes.
 *
 * @since 2.0.0
 * @category patch
 */
const empty = self => self.empty;

/**
 * @since 2.0.0
 * @category patch
 */
const diff = /*#__PURE__*/dual(3, (self, oldValue, newValue) => self.diff(oldValue, newValue));

/**
 * Combines two patches to produce a new patch that describes the updates of
 * the first patch and then the updates of the second patch. The combine
 * operation should be associative. In addition, if the combine operation is
 * commutative then joining multiple fibers concurrently will result in
 * deterministic `FiberRef` values.
 *
 * @since 2.0.0
 * @category patch
 */
const combine = /*#__PURE__*/dual(3, (self, first, second) => self.combine(first, second));

/**
 * Applies a patch to an old value to produce a new value that is equal to the
 * old value with the updates described by the patch.
 *
 * @since 2.0.0
 * @category patch
 */
const patch = /*#__PURE__*/dual(3, (self, patch, oldValue) => self.patch(patch, oldValue));

/**
 * Constructs a new `Differ`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Constructs a differ that knows how to diff `Env` values.
 *
 * @since 2.0.0
 * @category constructors
 */
const environment = environment$1;

/**
 * Constructs a differ that knows how to diff a `Chunk` of values given a
 * differ that knows how to diff the values.
 *
 * @since 2.0.0
 * @category constructors
 */
const chunk = chunk$1;

/**
 * Constructs a differ that knows how to diff a `HashMap` of keys and values given
 * a differ that knows how to diff the values.
 *
 * @since 2.0.0
 * @category constructors
 */
const hashMap = hashMap$1;

/**
 * Constructs a differ that knows how to diff a `HashSet` of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const hashSet = hashSet$1;

/**
 * Combines this differ and the specified differ to produce a differ that
 * knows how to diff the sum of their values.
 *
 * @since 2.0.0
 */
const orElseEither = orElseEither$1;

/**
 * Transforms the type of values that this differ knows how to differ using
 * the specified functions that map the new and old value types to each other.
 *
 * @since 2.0.0
 */
const transform = transform$1;

/**
 * Constructs a differ that just diffs two values by returning a function that
 * sets the value to the new value. This differ does not support combining
 * multiple updates to the value compositionally and should only be used when
 * there is no compositional way to update them.
 *
 * @since 2.0.0
 */
const update = update$1;

/**
 * A variant of `update` that allows specifying the function that will be used
 * to combine old values with new values.
 *
 * @since 2.0.0
 */
const updateWith = updateWith$1;

/**
 * Combines this differ and the specified differ to produce a new differ that
 * knows how to diff the product of their values.
 *
 * @since 2.0.0
 */
const zip = zip$1;

export { TypeId, chunk, combine, diff, empty, environment, hashMap, hashSet, make, orElseEither, patch, transform, update, updateWith, zip };
